<template>
  <div id="app">
    <transition :name="transitionName">   
      <router-view class="app-view"></router-view>
    </transition>
  </div>
</template>

<script>

export default {
  data() {
    return {
      transitionName: "",
    };
  },
  created(){
      // eruda.init();  
    this.mixGetLocation(location=>{
      this.$store.state.location = location
    })
    setInterval(_=>{
      this.mixGetLocation(location=>{
        this.$store.state.location = location
      })
    }, 50000)
    this.$store.commit('getTestStatus')
    setTimeout(_=> {
      this.$store.state.isTest && new VConsole();
    }, 10)
  },
  watch: {//使用watch 监听$router的变化
    $route(to, from) {
      if(to.meta.noAnimation)return true
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if(from.meta.index == undefined)return (this.transitionName = 'slide-left')
      if(to.meta.index > from.meta.index){
        //设置动画名称
        this.transitionName = 'slide-left';
      }else{
        this.transitionName = 'slide-right';
      }
    }
  }
};
</script>


<style lang="scss">
@import "./assets/iconfont/iconfont.css";
body{
  margin: 0;
}
.app-view {
  width: 100%;  
  height: 100%;  
  transition: all .2s cubic-bezier(.55,0,.1,1);
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 300ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.no-select {
  -webkit-touch-callout: none;
  user-select: none;
}
.ellipsis {
    /*文本强制不换行*/
    white-space: nowrap;
    /*文本溢出显示省略号*/
    text-overflow: ellipsis;
    /*溢出的部分隐藏*/
    overflow: hidden;
}
</style>
